import { createContext } from 'react';

/** Settings cards own the page heading when rendered without their card frame. */
export const PracticeSettingsPageContext = createContext(false);
